export default __webpack_public_path__ + "static/media/checkbox2--hover.7e7fc665.svg";